const portableBundle = (() => {
  const EL_SECTION = '[data-bundle-section]';
  const EL_BUTTON = '[data-bundle-button]';
  const EL_LINK = '[data-bundle-link]';

  let instances = {};
  let ticking = false;

  function toggleButton() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    Object.keys(instances).forEach(key => {
      const elButton = document.querySelector(`[data-bundle-button="${key}"]`);
      const bottom = instances[key].offset;
      let isActive = scrollTop > bottom;

      isActive ? elButton.classList.add('active') : elButton.classList.remove('active');
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        toggleButton();
        ticking = false;
      });
      ticking = true;
    }
  }

  function jumpToSection(ev) {
    ev.preventDefault();
    const elLink = ev.currentTarget;
    const id = elLink.getAttribute('data-bundle-link');

    window.scroll({
      top: instances[id].top - 126,
      left: 0,
      behavior: "smooth",
    });
  }

  function init() {
    const elSections = document.querySelectorAll(EL_SECTION);
    elSections.forEach(el => {
      const id = el.getAttribute('data-bundle-section');
      let offset = el.offsetTop + el.offsetHeight;

      instances[id] = {
        offset,
        top: el.offsetTop,
      };
    })

    const elLinks = document.querySelectorAll(EL_LINK);
    elLinks.forEach(el => {
      el.removeEventListener('click', jumpToSection);
      el.addEventListener('click', jumpToSection);
    })

    toggleButton();
    document.addEventListener("scroll", onScroll);
  }

  return {
    init
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  portableBundle.init();
})